export enum DrawStatus {
  ACTIVE = "ACTIVE",
  DRAWN = "DRAWN",
  INSPECTED = "INSPECTED",
  LENDER_PENDING = "LENDER_PENDING",
  FUNDED = "FUNDED",
  APPROVED = "APPROVED",
  PAID = "PAID",
  COMPLETED = "COMPLETED",
  DECLINED = "DECLINED",
}

export function getDrawStatusDisplayText(role: DrawStatus | null) {
  switch (role) {
    case DrawStatus.ACTIVE:
      return "Active";
    case DrawStatus.DRAWN:
      return "Drawn";
    case DrawStatus.INSPECTED:
      return "Inspected";
    case DrawStatus.LENDER_PENDING:
      return "Lender Pending";
    case DrawStatus.FUNDED:
      return "Funded";
    case DrawStatus.APPROVED:
      return "Approved";
    case DrawStatus.PAID:
      return "Paid";
    case DrawStatus.COMPLETED:
      return "Completed";
    case DrawStatus.DECLINED:
      return "Declined";
    default:
      return "";
  }
}

export function getDrawStatusDisplayColor(status: DrawStatus | null): string[] {
  switch (status) {
    case DrawStatus.ACTIVE:
      return ["border-l-blue-500 dark:border-l-blue-500/80", "bg-blue-500/20"];
    case DrawStatus.DRAWN:
      return ["border-l-orange-500 dark:border-l-orange-500/80", "bg-orange-500/20"];
    case DrawStatus.INSPECTED:
      return ["border-l-pink-500 dark:border-l-pink-500/80", "bg-pink-500/20"];
    case DrawStatus.LENDER_PENDING:
      return ["border-l-yellow-500 dark:border-l-yellow-500/80", "bg-yellow-500/20"];
    case DrawStatus.FUNDED:
      return ["border-l-cyan-500 dark:border-l-cyan-500/80", "bg-cyan-500/20"];
    case DrawStatus.APPROVED:
      return ["border-l-green-500 dark:border-l-green-500/80", "bg-green-500/20"];
    case DrawStatus.PAID:
      return ["border-l-purple-500 dark:border-l-purple-500/80", "bg-purple-500/20"];
    case DrawStatus.COMPLETED:
      return ["border-l-teal-500 dark:border-l-teal-500/80", "bg-teal-500/20"];
    case DrawStatus.DECLINED:
      return ["border-l-red-500 dark:border-l-red-500/80", "bg-red-500/20"];
    default:
      return ["", ""];
  }
}

export function getDrawStatusSeverity(status: DrawStatus | null): string {
  switch (status) {
    case DrawStatus.ACTIVE:
    case DrawStatus.APPROVED:
    case DrawStatus.COMPLETED:
      return "success";
    case DrawStatus.INSPECTED:
      return "help";
    case DrawStatus.LENDER_PENDING:
      return "warning";
    case DrawStatus.DECLINED:
      return "danger";
    case DrawStatus.FUNDED:
    case DrawStatus.DRAWN:
    case DrawStatus.PAID:
    default:
      return "info";
  }
}
